import { ProgramName } from '@/types/enrollment';
import { CurrentSiteItem } from '@/types/sites';

// Returns program that a site is enrolled in. If none, returns DATA_ONLY since DATA_ONLY is for customers not enrolled in any program
export const getProgramNameFromSite = (site?: CurrentSiteItem, fallbackProgram?: ProgramName) => {
  const programName = site?.program?.program;
  return programName || fallbackProgram || ProgramName.NONE;
};
